import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logoMyPlant.svg'


const _withScopeId = n => (_pushScopeId("data-v-427b2052"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "logo myPlant"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", null, [
    _hoisted_1,
    _createElementVNode("button", {
      class: "button",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.alterarTema && _ctx.alterarTema(...args)))
    }, _toDisplayString(_ctx.textoBotao), 1)
  ]))
}